import AntResult, { type ResultProps as AntResultProps } from "antd/lib/result";

export type ResultProps = AntResultProps;

export const Result = (props: ResultProps) => {
    return <AntResult {...props} />;
};
